// Analytics Events
export const ANALYTICS_EVENTS = {
	PRODUCT_FINDER_STEP: 'product_finder_step',
	PRODUCT_FINDER_RESULT: 'product_finder_result',
	PRODUCT_FINDER_ERROR: 'product_finder_error',
	PRODUCT_FINDER_LEAD: 'product_finder_lead',
	PRODUCT_FINDER_LAUNCH: 'product_finder_launch'
}

export const PRODUCT_FINDER_NAME = 'diagnostic'

// Export all constants as a single object for global registration
export default {
	ANALYTICS_EVENTS,
	PRODUCT_FINDER_NAME
}
